import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {Scanner3dAccountConverter} from './api/entity/converter/scanner3dAccount.converter';
import {Scanner3dAccountRepository} from './impl/service/ngrx/scanner3dAccount.repository';
import {Scanner3dAccountDataService} from './impl/service/ngrx/scanner3dAccountData.service';
import {Scanner3dAccountDataServiceAdapter} from './impl/service/ngrx/scanner3dAccountDataService.adapter';
import {Scanner3dAccountFindOneByIdService} from './impl/service/scanner3dAccountFindOneById.service';
import {Scanner3dAccountDeleteService} from './impl/service/scanner3dAccountDelete.service';
import {Scanner3dAccountPaginatedService} from './impl/service/scanner3dAccountPaginated.service';
import {Scanner3dAccountSaveService} from './impl/service/scanner3dAccountSave.service';

@NgModule({
    providers: [
        Scanner3dAccountConverter,

        Scanner3dAccountRepository,
        Scanner3dAccountDataService,
        Scanner3dAccountDataServiceAdapter,

        Scanner3dAccountFindOneByIdService,
        Scanner3dAccountDeleteService,
        Scanner3dAccountPaginatedService,
        Scanner3dAccountSaveService,

    ],
})
export class Scanner3dAccountModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: Scanner3dAccountRepository,
                 dataService: Scanner3dAccountDataService,
    ) {

        entityDataService.registerServices({
            Scanner3dAccount: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Scanner3dAccount: repository,
        });

        // errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà %1');
    }
}
